import type { Filter } from '@spendesk/bookkeeping-core-types';
import type * as D from '@spendesk/general-type-helpers/Date';
import { useParams } from 'react-router-dom';

import { useFeature } from 'common/hooks/useFeature';
import FEATURES from 'src/core/constants/features';

import { reshapePayableCounts } from './mappers';
import { GET_PAYABLES_TO_PREPARE_COUNTS } from './queries';
import { useQuery } from '../hooks/useQuery';

export const usePayableCounts = (creationDate?: { to?: Date }) => {
  const { company: companyId } = useParams();
  const hasPayableFeature = useFeature(FEATURES.BOOKKEEP_PAYABLES);

  const prepareFilters: Filter[] = [
    {
      field: 'bookkeepingStatus',
      operator: '=',
      value: ['toPrepare'],
    },
    {
      field: 'withBookkeepingStartDate',
      operator: '=',
      value: true,
    },
  ];
  if (creationDate?.to) {
    prepareFilters.push({
      field: 'payableDate',
      operator: 'before',
      value: creationDate.to as D.ValidDate,
    });
  }

  const queryOptions = {
    isEnabled: hasPayableFeature,
    variables: {
      companyId,
      prepareFilters: {
        operator: 'and',
        subfilters: prepareFilters,
      },
    },
  };

  return useQuery(GET_PAYABLES_TO_PREPARE_COUNTS, queryOptions, {
    reshapeData: reshapePayableCounts,
  });
};
